// extracted by mini-css-extract-plugin
export default {"libraryDesignButtonWrapper":"lDXQDqiYTfMNFAeDmhoI"};